import service from '../utils/request';

// 任务管理相关API
// 获取任务列表
export const getTaskList = (params) => {

  return service.get('/tasks/list', { params });
};

// 获取待审核任务列表
export const getPendingReviewTaskList = (params) => {

  return service.get('/tasks/review/pending', { params });
};

// 审核任务
export const reviewTask = (id, data) => {
  return service.post(`/tasks/${id}/review`, data);
};

// 任务状态相关API
// 获取任务状态变更历史列表
export const getTaskStatusHistoryList = (params) => {

  return service.get('/task-status/history/list', { params });
};

// 任务报名与抢单相关API
// 获取任务报名列表
export const getTaskSignupList = (params) => {
  return service.get('/task-applications/signup/list', { params });
};

// 获取用户报名历史列表
export const getTaskSignupHistoryList = (params) => {
  console.log("params",params)
  return service.get('/task-applications/signup/history/list', { params });
};

// 获取任务抢单列表
export const getTaskGrabList = (params) => {
  return service.get('/task-applications/grab/list', { params });
};

// 获取用户抢单历史列表
export const getTaskGrabHistoryList = (params) => {
 
  return service.get('/task-applications/grab/history/list', { params });
};

// 获取任务录取列表
export const getTaskAdmissionList = (params) => {
  return service.get('/task-applications/admission/list', { params });
};

// 任务完成申请与验收相关API
// 获取任务完成申请列表
export const getTaskCompletionApplyList = (params) => {
 
  return service.get('/task-completion/apply/list', { params });
};

// 获取任务完成申请历史列表
export const getTaskCompletionApplyHistoryList = (params) => {

  return service.get('/task-completion/apply/history/list', { params });
};

// 验收任务完成申请
export const verifyTaskCompletionApply = (id, data) => {
  return service.post(`/task-completion/apply/${id}/verify`, data);
};

// 任务结算相关API
// 获取任务结算列表
export const getTaskSettlementList = (params) => {

  return service.get('/task-settlements/list', { params });
};

// 任务保证金账户相关API
// 获取任务保证金账户列表
export const getTaskDepositList = (params) => {
  return service.get('/task-deposits/list', { params });
};

// 获取保证金流水列表
export const getDepositTransactionList = (params) => {
  return service.get('/task-deposits/transactions', { params });
}; 

// 获取保证金账户变更记录列表
export const getDepositChangeHistoryList = (params) => {
  return service.get('/task-deposits/change-history', { params });
}; 